"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolNode = void 0;
const base_1 = require("./base");
const antlr_files_1 = require("../antlr_files");
const operatorTerminals = new Set([
    antlr_files_1.Lexer.BOOLEAN_OPERATIONS,
    antlr_files_1.Lexer.COMPARISON_OPERATIONS,
    antlr_files_1.Lexer.DIV,
    antlr_files_1.Lexer.MINUS,
    antlr_files_1.Lexer.PLUS,
    antlr_files_1.Lexer.POW,
    antlr_files_1.Lexer.TIMES,
    antlr_files_1.Lexer.PERCENTAGE,
]);
class SymbolNode extends base_1.LeafNode {
    terminalType;
    isTextFormatted = false;
    constructor(originalNode, parent) {
        super(originalNode, parent);
        // force translation of = to ==
        if (this._token === '=') {
            this.abstractText = '==';
            this._translation = '==';
        }
        // force translation of <> to !=
        if (this._token === '<>') {
            this.abstractText = '!=';
            this._translation = '!=';
        }
        this.terminalType = originalNode.symbol.type;
        this._startPosition = originalNode.symbol.start;
        this._endPosition = originalNode.symbol.stop + 1;
        this._treeNodeType = base_1.TreeNodeType.SYMBOL_NODE;
    }
    translate(_opts) {
        this.formatText();
        return this._translation;
    }
    toString() {
        this.formatText();
        return super.toString();
    }
    accept(v) {
        if (v.visitSymbol)
            v.visitSymbol(this);
    }
    formatText() {
        if (this.isTextFormatted)
            return;
        this.isTextFormatted = true;
        // adds spaces around operators
        if (operatorTerminals.has(this.terminalType)) {
            this.abstractText = ` ${this.abstractText} `;
            this._translation = ` ${this._translation} `;
        }
    }
    getReturnType() {
        return '';
    }
}
exports.SymbolNode = SymbolNode;
